import { useState } from "react";
import { useHealth, useHeld, useNow, useSession, useView, viewOf } from "../../client/index.ts";
import { healthText } from "../../design/format/status.ts";
import { Dot } from "../../design/primitives/Dot.tsx";
import { Link } from "../navigation/Link.tsx";
import { useNavigation } from "../navigation/Navigation.tsx";
import { lateReads } from "./late.ts";
import styles from "./TopBar.module.css";

export const contas = viewOf("contas")();

function useAfterThePage(): boolean {
  const key = useNavigation().route.opened?.key;
  const page = useHeld(key);
  const [after, setAfter] = useState(key === undefined);
  if (!after && (key === undefined || page?.held !== undefined || page?.error !== undefined)) setAfter(true);
  return after;
}

export function Freshness() {
  const state = useView(useAfterThePage() ? contas : undefined);
  const session = useSession();
  const now = useNow();
  const level = useNavigation().route.match?.entry.level;
  const view = state.status === "pronta" ? state.data : undefined;
  const health = useHealth(view?.health);
  if (!view) return null;
  const sourceName = session.status === "dentro" ? session.view.ui.labels.fonteVendas?.nome : undefined;
  const reads = level === "empresa" || level === "conta" ? [] : lateReads(view, sourceName, now);
  const schedule = healthText(health, now);
  if (reads.length === 0 && schedule === undefined) return null;
  const summary = [...reads, ...(schedule ? [schedule.text] : [])].join(" · ");
  return (
    <>
      <Link href="/contas" className={styles.fresh}>
        {[...reads.map((text) => ({ text, tone: styles.late })), ...(schedule ? [{ text: schedule.text, tone: schedule.tone === "negativo" ? styles.stopped : styles.late }] : [])].map((part, index) => (
          <span key={part.text} className={part.tone}>
            {index > 0 ? " · " : ""}
            {part.text}
          </span>
        ))}
      </Link>
      <Link href="/contas" className={styles.freshDot} aria-label={summary}>
        <Dot kind={schedule?.tone ?? "atencao"} />
      </Link>
    </>
  );
}
